import React from 'react';
import { Paper, Box, Typography, Avatar, Chip } from '@mui/material';

export default function StatCard({ title, value, icon, color = 'primary', helpText, breakdown }) {
  return (
    <Paper sx={{ p: 2, overflow: 'hidden', position: 'relative' }}>
      <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, background: (t) => t.palette[color]?.main || t.palette.primary.main, opacity: 0.8 }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {icon && (
          <Avatar
            sx={{
              bgcolor: (t) => (t.palette.background.paper),
              color: (t) => (t.palette[color]?.main || t.palette.primary.main),
              border: (t) => `2px solid ${t.palette[color]?.main || t.palette.primary.main}`,
              width: 40,
              height: 40,
            }}
          >
            {icon}
          </Avatar>
        )}
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1, textTransform: 'uppercase' }}>
            {title}
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
            {typeof value === 'number' ? value.toLocaleString() : value}
          </Typography>
          {helpText && (
            <Typography variant="caption" color="text.secondary">{helpText}</Typography>
          )}
          {Array.isArray(breakdown) && breakdown.length > 0 && (
            <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {breakdown.map((item, idx) => (
                <Chip
                  key={idx}
                  size="small"
                  icon={item.icon || undefined}
                  label={`${item.label}: ${item.value?.toLocaleString?.() ?? item.value}`}
                  sx={{
                    bgcolor: (t) => t.palette.mode === 'light' ? 'background.default' : 'background.paper',
                    border: '1px solid',
                    borderColor: item.color || 'divider',
                    color: item.color || 'text.primary',
                  }}
                  variant="outlined"
                />
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
}

